// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conversation-context-menu {
  position: fixed;
  z-index: 1000;
  background: rgb(242, 242, 242);
  border-radius: 8px;
  box-shadow: rgb(0 0 0 / 4%) 0px 10px 20px, rgb(0 0 0 / 15%) 0px 6px 6px;
  padding: 4px 0;
  min-width: 180px;
}

.conversation-context-menu button {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: none;
  text-align: left;
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  color: #434343;
  cursor: pointer;
}

.conversation-context-menu button:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.conversation-context-menu button ion-icon {
  font-size: 18px;
  color: #6A6A6A;
}

.conversation-context-menu button:first-child {
  border-radius: 8px 8px 0 0;
}

.conversation-context-menu button:last-child {
  border-radius: 0 0 8px 8px;
}

.conversation-context-menu button:only-child {
  border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ConversationContextMenu.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,uEAAuE;EACvE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".conversation-context-menu {\n  position: fixed;\n  z-index: 1000;\n  background: rgb(242, 242, 242);\n  border-radius: 8px;\n  box-shadow: rgb(0 0 0 / 4%) 0px 10px 20px, rgb(0 0 0 / 15%) 0px 6px 6px;\n  padding: 4px 0;\n  min-width: 180px;\n}\n\n.conversation-context-menu button {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 14px;\n  border: none;\n  background: none;\n  text-align: left;\n  font-family: Roboto, Arial, sans-serif;\n  font-size: 14px;\n  color: #434343;\n  cursor: pointer;\n}\n\n.conversation-context-menu button:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.conversation-context-menu button ion-icon {\n  font-size: 18px;\n  color: #6A6A6A;\n}\n\n.conversation-context-menu button:first-child {\n  border-radius: 8px 8px 0 0;\n}\n\n.conversation-context-menu button:last-child {\n  border-radius: 0 0 8px 8px;\n}\n\n.conversation-context-menu button:only-child {\n  border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
